/* ============================================================
   TEJAHOME Theme — Main JavaScript
   Premium Indian Home & Kitchen E-commerce
   ============================================================ */

(function() {
  'use strict';

  /* ---------- Utility Functions ---------- */
  const $ = (selector, parent = document) => parent.querySelector(selector);
  const $$ = (selector, parent = document) => [...parent.querySelectorAll(selector)];

  function debounce(fn, delay = 250) {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => fn(...args), delay);
    };
  }

  function formatMoney(cents) {
    return '₹' + (cents / 100).toLocaleString('en-IN');
  }

  const NO_IMAGE_PLACEHOLDER = 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">' +
    '<rect width="100" height="100" fill="#EEF1F5"/>' +
    '<path d="M30 65 L42 50 L52 60 L66 42 L78 65 Z" fill="#C7CEDB"/>' +
    '<circle cx="38" cy="35" r="7" fill="#C7CEDB"/>' +
    '</svg>'
  );

  function initStickyHeader() {
    const header = $('.site-header');
    if (!header) return;
    let lastScroll = 0;
    const scrollThreshold = 50;
    window.addEventListener('scroll', () => {
      const currentScroll = window.pageYOffset;
      if (currentScroll > scrollThreshold) { header.classList.add('scrolled'); } else { header.classList.remove('scrolled'); }
      lastScroll = currentScroll;
    }, { passive: true });
  }

  function initMobileMenu() {
    const toggle = $('.header__menu-toggle');
    const menu = $('.mobile-menu');
    const close = $('.mobile-menu__close');
    const overlay = $('.overlay');
    if (!toggle || !menu) return;
    function openMenu() { menu.classList.add('open'); document.body.classList.add('menu-open'); if (overlay) overlay.classList.add('active'); }
    function closeMenu() { menu.classList.remove('open'); document.body.classList.remove('menu-open'); if (overlay) overlay.classList.remove('active'); }
    toggle.addEventListener('click', openMenu);
    if (close) close.addEventListener('click', closeMenu);
    if (overlay) overlay.addEventListener('click', closeMenu);
    $$('.mobile-menu__link[data-toggle]').forEach(link => {
      link.addEventListener('click', (e) => { e.preventDefault(); const item = link.closest('.mobile-menu__item'); item.classList.toggle('open'); });
    });
  }

  function initHeroSlideshow() {
    const slideshow = $('.hero-slideshow');
    if (!slideshow) return;
    const track = $('.hero-slideshow__track', slideshow);
    const slides = $$('.hero-slideshow__slide', slideshow);
    const dots = $$('.hero-slideshow__dot', slideshow);
    const prevBtn = $('.hero-slideshow__nav--prev', slideshow);
    const nextBtn = $('.hero-slideshow__nav--next', slideshow);
    if (slides.length <= 1) return;
    let current = 0; let autoplayTimer; const autoplayDelay = 5000;
    function goTo(index) {
      if (index < 0) index = slides.length - 1;
      if (index >= slides.length) index = 0;
      current = index;
      track.style.transform = `translateX(-${current * 100}%)`;
      dots.forEach((dot, i) => { dot.classList.toggle('active', i === current); });
    }
    function next() { goTo(current + 1); }
    function prev() { goTo(current - 1); }
    function startAutoplay() { stopAutoplay(); autoplayTimer = setInterval(next, autoplayDelay); }
    function stopAutoplay() { clearInterval(autoplayTimer); }
    if (prevBtn) prevBtn.addEventListener('click', () => { prev(); startAutoplay(); });
    if (nextBtn) nextBtn.addEventListener('click', () => { next(); startAutoplay(); });
    dots.forEach((dot, i) => { dot.addEventListener('click', () => { goTo(i); startAutoplay(); }); });
    let touchStartX = 0; let touchEndX = 0;
    track.addEventListener('touchstart', (e) => { touchStartX = e.changedTouches[0].screenX; stopAutoplay(); }, { passive: true });
    track.addEventListener('touchend', (e) => {
      touchEndX = e.changedTouches[0].screenX;
      const diff = touchStartX - touchEndX;
      if (Math.abs(diff) > 50) { diff > 0 ? next() : prev(); }
      startAutoplay();
    }, { passive: true });
    startAutoplay();
  }

  function initProductCarousels() {
    $$('.products-carousel').forEach(carousel => {
      const track = $('.products-carousel__track', carousel);
      const prevBtn = $('.carousel__nav--prev', carousel);
      const nextBtn = $('.carousel__nav--next', carousel);
      if (!track) return;
      const items = track.children;
      if (items.length === 0) return;
      let scrollAmount = 0;
      function getItemWidth() { const style = window.getComputedStyle(track); const gap = parseInt(style.gap) || 24; return items[0].offsetWidth + gap; }
      function getVisibleItems() { const width = carousel.offsetWidth; const itemWidth = items[0].offsetWidth; return Math.floor(width / itemWidth); }
      function scrollTo(amount) { const maxScroll = track.scrollWidth - carousel.offsetWidth; scrollAmount = Math.max(0, Math.min(amount, maxScroll)); track.style.transform = `translateX(-${scrollAmount}px)`; }
      if (prevBtn) { prevBtn.addEventListener('click', () => { scrollTo(scrollAmount - getItemWidth() * Math.max(1, getVisibleItems() - 1)); }); }
      if (nextBtn) { nextBtn.addEventListener('click', () => { scrollTo(scrollAmount + getItemWidth() * Math.max(1, getVisibleItems() - 1)); }); }
      let startX = 0; let startScroll = 0; let isDragging = false;
      track.addEventListener('touchstart', (e) => { startX = e.touches[0].pageX; startScroll = scrollAmount; isDragging = true; }, { passive: true });
      track.addEventListener('touchmove', (e) => { if (!isDragging) return; const diff = startX - e.touches[0].pageX; scrollTo(startScroll + diff); }, { passive: true });
      track.addEventListener('touchend', () => { isDragging = false; const itemWidth = getItemWidth(); scrollTo(Math.round(scrollAmount / itemWidth) * itemWidth); }, { passive: true });
    });
  }

  function initReviewCarousel() {
    $$('.reviews-carousel').forEach(carousel => {
      const track = $('.reviews-carousel__track', carousel);
      const prevBtn = $('.carousel__nav--prev', carousel);
      const nextBtn = $('.carousel__nav--next', carousel);
      if (!track) return;
      let scrollAmount = 0;
      function getCardWidth() { const card = track.children[0]; if (!card) return 300; const style = window.getComputedStyle(track); const gap = parseInt(style.gap) || 24; return card.offsetWidth + gap; }
      function scroll(direction) { const maxScroll = track.scrollWidth - carousel.offsetWidth; scrollAmount = Math.max(0, Math.min(scrollAmount + direction * getCardWidth(), maxScroll)); track.style.transform = `translateX(-${scrollAmount}px)`; }
      if (prevBtn) prevBtn.addEventListener('click', () => scroll(-1));
      if (nextBtn) nextBtn.addEventListener('click', () => scroll(1));
      let startX = 0;
      track.addEventListener('touchstart', (e) => { startX = e.touches[0].pageX; }, { passive: true });
      track.addEventListener('touchend', (e) => { const diff = startX - e.changedTouches[0].pageX; if (Math.abs(diff) > 50) { scroll(diff > 0 ? 1 : -1); } }, { passive: true });
    });
  }

  function initProductGallery() {
    const gallery = $('.product-gallery');
    if (!gallery) return;
    const mainImage = $('.product-gallery__main-image', gallery);
    const thumbs = $$('.product-gallery__thumb', gallery);
    thumbs.forEach(thumb => {
      thumb.addEventListener('click', () => {
        const newSrc = thumb.dataset.fullImage || thumb.querySelector('img').src;
        mainImage.src = newSrc;
        thumbs.forEach(t => t.classList.remove('active'));
        thumb.classList.add('active');
      });
    });
  }

  function initProductTabs() {
    $$('.product-tabs').forEach(tabContainer => {
      const tabs = $$('.product-tabs__tab', tabContainer);
      const panels = $$('.product-tabs__panel', tabContainer);
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => {
          tabs.forEach(t => t.classList.remove('active'));
          panels.forEach(p => p.classList.remove('active'));
          tab.classList.add('active');
          panels[index].classList.add('active');
        });
      });
    });
  }

  function initVariantSelector() {
    $$('.variant-option').forEach(option => {
      option.addEventListener('click', function() {
        if (this.classList.contains('unavailable')) return;
        const group = this.closest('.variant-options');
        if (!group) return;
        $$('.variant-option', group).forEach(opt => opt.classList.remove('selected'));
        this.classList.add('selected');
        const groupLabelVal = this.closest('.variant-group')?.querySelector('.variant-group__selected-val');
        if (groupLabelVal) groupLabelVal.textContent = this.dataset.value;
        const selectedValues = Array.from(document.querySelectorAll('.variant-group')).map(g => { const sel = g.querySelector('.variant-option.selected'); return sel ? sel.dataset.value : null; });
        let matchingVariant = null;
        if (window.productData && window.productData.variants) {
          matchingVariant = window.productData.variants.find(v => { return selectedValues.every((val, idx) => v.options[idx] === val); });
        }
        const selectHidden = document.getElementById('ProductSelectHidden');
        const select = document.getElementById('ProductVariantSelect');
        if (matchingVariant) {
          if (selectHidden) selectHidden.value = matchingVariant.id;
          if (select) select.value = matchingVariant.id;
          window.currentVariantId = matchingVariant.id;
          const currentPrice = document.querySelector('.product-info__price-current');
          if (currentPrice) currentPrice.textContent = formatMoney(matchingVariant.price);
          const stickyPrice = document.getElementById('StickyBarPrice');
          if (stickyPrice) stickyPrice.textContent = formatMoney(matchingVariant.price);
          const comparePrice = document.querySelector('.product-info__price-compare');
          if (comparePrice) {
            if (matchingVariant.compare_at_price > matchingVariant.price) { comparePrice.textContent = 'M.R.P. ' + formatMoney(matchingVariant.compare_at_price); comparePrice.style.display = 'inline'; } else { comparePrice.style.display = 'none'; }
          }
          const submitBtn = document.querySelector('.product-info__add-to-cart');
          if (submitBtn) {
            if (matchingVariant.available) { submitBtn.disabled = false; submitBtn.textContent = 'Add to Cart'; } else { submitBtn.disabled = true; submitBtn.textContent = 'Sold Out'; }
          }
          if (matchingVariant.featured_image && matchingVariant.featured_image.src) { const mainImg = document.getElementById('ProductMainImage'); if (mainImg) mainImg.src = matchingVariant.featured_image.src; }
        } else if (select) {
          const matchOpt = Array.from(select.options).find(o => o.text.includes(this.dataset.value));
          if (matchOpt) { select.value = matchOpt.value; if (selectHidden) selectHidden.value = matchOpt.value; window.currentVariantId = matchOpt.value; }
        }
      });
    });
  }

  function initQuantitySelectors() {
    $$('.quantity-selector').forEach(selector => {
      const input = $('input', selector);
      const minusBtn = $('.quantity-selector__btn--minus', selector);
      const plusBtn = $('.quantity-selector__btn--plus', selector);
      if (!input) return;
      const parsedMin = parseInt(input.min, 10);
      const min = Number.isNaN(parsedMin) ? 1 : parsedMin;
      const max = parseInt(input.max) || 99;
      function update(value) { value = Math.max(min, Math.min(max, value)); input.value = value; input.dispatchEvent(new Event('change', { bubbles: true })); }
      if (minusBtn) { minusBtn.addEventListener('click', () => update(parseInt(input.value) - 1)); }
      if (plusBtn) { plusBtn.addEventListener('click', () => update(parseInt(input.value) + 1)); }
      input.addEventListener('change', () => { let val = parseInt(input.value); if (isNaN(val) || val < min) val = min; if (val > max) val = max; input.value = val; });
    });
  }

  function normalizeBuyNowLabels() {
    document.querySelectorAll('[data-buy-now], .product-info__buy-now, .th-sticky-buy').forEach(btn => {
      if (btn && !btn.disabled) { const hasIcon = btn.textContent.trim().startsWith('⚡'); btn.textContent = hasIcon ? '⚡ Buy Now' : 'Buy Now'; }
    });
  }
  try { normalizeBuyNowLabels(); } catch (e) {}

  function initAddToCart() {
    document.addEventListener('click', function(e) {
      const btn = e.target.closest('[name="checkout"], [data-buy-now], .product-info__buy-now, .btn--buy-now, .th-btn--buy, .product-card__add-btn');
      if (btn) { const form = btn.closest('form'); if (form) { form.dataset.checkoutSubmit = 'true'; } }
    }, true);
    $$('form[action="/cart/add"], form[action$="/cart/add"]').forEach(form => {
      form.addEventListener('submit', async function(e) {
        const submitter = e.submitter || document.activeElement;
        const isCheckout = form.dataset.checkoutSubmit === 'true' || (!!submitter && (
          submitter.matches('[name=checkout]') || submitter.matches('[data-buy-now]') || submitter.classList.contains('shopify-payment-button__button') || submitter.classList.contains('btn--buy-now') || submitter.classList.contains('product-card__add-btn') || submitter.classList.contains('product-info__buy-now') || submitter.classList.contains('th-btn--buy')
        ));
        delete form.dataset.checkoutSubmit;
        e.preventDefault();
        const submitBtn = submitter || $('[type="submit"]', form);
        const originalText = submitBtn?.textContent;
        if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = isCheckout ? 'Redirecting…' : 'Adding...'; }
        try {
          const formData = new FormData(form);
          const response = await fetch('/cart/add.js', { method: 'POST', body: formData });
          if (!response.ok) {
            let message = 'Failed to add to cart';
            try { const errData = await response.json(); if (errData?.description) message = errData.description; } catch (parseErr) {}
            throw new Error(message);
          }
          const item = await response.json();
          if (isCheckout) { window.location.href = '/checkout'; return; }
          updateCartCount();
          if (typeof window.openCartDrawer === 'function') { window.openCartDrawer(); }
          showToast(`✓ ${item.title} added to cart!`);
        } catch (err) {
          showToast(err.message || 'Could not add to cart. Please try again.', 'error');
        } finally {
          if (submitBtn && !isCheckout) { submitBtn.disabled = false; submitBtn.textContent = originalText; }
        }
      });
    });
  }

  async function updateCartCount() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      $$('.header__cart-count').forEach(el => { el.textContent = cart.item_count; el.style.display = cart.item_count > 0 ? 'flex' : 'none'; });
      const bottomNavBadge = document.getElementById('MobileBottomNavCount');
      if (bottomNavBadge) { bottomNavBadge.textContent = cart.item_count; bottomNavBadge.style.display = cart.item_count > 0 ? 'flex' : 'none'; }
    } catch (err) {}
  }

  function showToast(message, type = 'success') {
    $$('.toast').forEach(t => t.remove());
    const toast = document.createElement('div');
    toast.className = 'toast';
    if (type === 'error') { toast.style.background = 'var(--color-sale)'; }
    toast.innerHTML = `<span>${message}</span><button class="toast__close" aria-label="Close">✕</button>`;
    document.body.appendChild(toast);
    requestAnimationFrame(() => { toast.classList.add('show'); });
    const hideTimer = setTimeout(() => { toast.classList.remove('show'); setTimeout(() => toast.remove(), 400); }, 3500);
    $('.toast__close', toast)?.addEventListener('click', () => { clearTimeout(hideTimer); toast.classList.remove('show'); setTimeout(() => toast.remove(), 400); });
  }

  function initScrollReveal() {
    const elements = $$('.reveal, .reveal-left, .reveal-right, .reveal-scale');
    if (elements.length === 0) return;
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => { if (entry.isIntersecting) { entry.target.classList.add('revealed'); observer.unobserve(entry.target); } });
    }, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' });
    elements.forEach(el => observer.observe(el));
  }

  function initAnnouncementRotation() {
    const bar = $('.announcement-bar--rotating');
    if (!bar) return;
    const messages = $$('.announcement-bar__message', bar);
    if (messages.length <= 1) return;
    let current = 0;
    setInterval(() => { messages[current].style.opacity = '0'; current = (current + 1) % messages.length; messages[current].style.opacity = '1'; }, 4000);
  }

  function initSearch() {
    const input = document.getElementById('HeaderSearchInput');
    const container = document.getElementById('HeaderSearchResults');
    if (!input || !container) return;
    const performSearch = debounce(async (query) => {
      query = query.trim();
      if (query.length < 2) { container.classList.remove('active'); container.innerHTML = ''; return; }
      try {
        container.innerHTML = '<div style="padding:1rem;text-align:center;font-size:0.85rem;color:var(--color-text-light);">Searching for "' + query + '"...</div>';
        container.classList.add('active');
        const res = await fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last`, { headers: { Accept: 'application/json' } });
        if (!res.ok) throw new Error('suggest.json responded with HTTP ' + res.status);
        const contentType = res.headers.get('content-type') || '';
        if (contentType.indexOf('json') === -1) { throw new Error('suggest.json returned non-JSON content-type "' + contentType + '" — store may be password-protected or this preview is not the live storefront domain'); }
        const data = await res.json();
        const products = Array.isArray(data?.resources?.results?.products) ? data.resources.results.products : [];
        if (products.length === 0) {
          container.innerHTML = `<div style="padding:1.2rem;text-align:center;"><div style="font-size:1.5rem;margin-bottom:0.25rem;">🔍</div><div style="font-size:0.875rem;font-weight:700;color:#172A46;">No instant products found for "${query}"</div><div style="font-size:0.75rem;color:#5E6B7E;margin-top:0.25rem;">Press Enter to see the full Shopify search results.</div><a href="/search?type=product&q=${encodeURIComponent(query)}" style="display:inline-flex;margin-top:.75rem;padding:.6rem .9rem;border-radius:9px;background:#0FAF9F;color:#071411;font-weight:800;text-decoration:none;">View Search Results</a></div>`;
          return;
        }
        const esc = (value) => String(value ?? '').replace(/[&<>"']/g, (c) => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
        let html = '';
        products.forEach(p => {
          const imgUrl = p.image || p.featured_image?.url || p.featured_image || NO_IMAGE_PLACEHOLDER;
          const productUrl = p.url || (p.handle ? '/products/' + p.handle : '/search?type=product&q=' + encodeURIComponent(query));
          const rawPrice = typeof p.price === 'number' ? p.price : parseFloat(String(p.price || '').replace(/[^0-9.]/g, ''));
          const price = Number.isFinite(rawPrice) ? formatMoney(Math.round(rawPrice * 100)) : '';
          const safeUrl = esc(productUrl); const safeImg = esc(imgUrl); const safeTitle = esc(p.title || 'Product');
          html += `<a href="${safeUrl}" class="search-result-item"><img src="${safeImg}" alt="${safeTitle}" class="search-result-item__image" width="48" height="48" loading="lazy"><div class="search-result-item__info"><div class="search-result-item__title">${safeTitle}</div><div class="search-result-item__price">${esc(price)}</div></div></a>`;
        });
        html += `<div class="search-results-footer"><a href="/search?type=product&q=${encodeURIComponent(query)}">View all results for "${query}" →</a></div>`;
        container.innerHTML = html;
        container.classList.add('active');
      } catch (err) {
        console.error('[header predictive search] request failed:', err);
        container.innerHTML = `<div class="search-results-footer" style="border:none;padding:0.75rem 0;"><a href="/search?type=product&q=${encodeURIComponent(query)}">Press Enter to search for "${query}" →</a></div>`;
        container.classList.add('active');
      }
    }, 200);
    input.addEventListener('input', (e) => performSearch(e.target.value));
    input.addEventListener('focus', () => { if (input.value.trim().length >= 2 && container.children.length > 0) { container.classList.add('active'); } });
    document.addEventListener('click', (e) => { if (!input.contains(e.target) && !container.contains(e.target)) { container.classList.remove('active'); } });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') { container.classList.remove('active'); } });
  }

  function initNewsletterForm() {
    $$('.newsletter__form').forEach(form => {
      form.addEventListener('submit', function(e) {
        const btn = $('button', form);
        if (btn) { const originalText = btn.textContent; btn.textContent = 'Subscribing...'; btn.disabled = true; setTimeout(() => { btn.textContent = originalText; btn.disabled = false; }, 3000); }
      });
    });
  }

  function initLazyLoad() {
    if ('loading' in HTMLImageElement.prototype) {
      $$('img[data-src]').forEach(img => { img.src = img.dataset.src; if (img.dataset.srcset) img.srcset = img.dataset.srcset; });
    } else {
      const observer = new IntersectionObserver((entries) => { entries.forEach(entry => { if (entry.isIntersecting) { const img = entry.target; img.src = img.dataset.src; if (img.dataset.srcset) img.srcset = img.dataset.srcset; observer.unobserve(img); } }); });
      $$('img[data-src]').forEach(img => observer.observe(img));
    }
  }

  window.openCartDrawer = async function() {
    const drawer = document.getElementById('CartDrawer');
    if (!drawer) return;
    drawer.style.display = 'block'; drawer.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden';
    await refreshCartDrawer();
  };
  window.closeCartDrawer = function() {
    const drawer = document.getElementById('CartDrawer');
    if (!drawer) return;
    drawer.style.display = 'none'; drawer.setAttribute('aria-hidden', 'true'); document.body.style.overflow = '';
  };

  async function refreshCartDrawer() {
    try {
      const res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      if (!res.ok) throw new Error('Cart unavailable');
      const cart = await res.json();
      const countEl = document.getElementById('CartDrawerCount'); if (countEl) countEl.textContent = cart.item_count;
      const subtotalEl = document.getElementById('CartDrawerSubtotal'); if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
      const drawerEl = document.getElementById('CartDrawer');
      const threshold = parseInt(drawerEl?.dataset.freeShippingThreshold, 10) || 49900;
      const fillEl = document.getElementById('CartDrawerShippingFill');
      const textEl = document.getElementById('CartDrawerShippingText');
      const pct = Math.min((cart.total_price / threshold) * 100, 100);
      if (fillEl) fillEl.style.width = pct + '%';
      if (textEl) {
        if (cart.total_price >= threshold) { textEl.innerHTML = '🎉 You\'ve unlocked <strong style="color:var(--color-success);">FREE EXPRESS SHIPPING!</strong>'; }
        else { const rem = formatMoney(threshold - cart.total_price); textEl.innerHTML = `Add <strong style="color:var(--color-accent);">${rem}</strong> more for <strong style="color:var(--color-primary);">FREE SHIPPING!</strong>`; }
      }
      const listEl = document.getElementById('CartDrawerItemsList');
      if (listEl) {
        if (cart.items.length === 0) {
          listEl.innerHTML = `<div style="text-align:center; padding:var(--space-2xl) 0;"><div style="font-size:3rem; margin-bottom:var(--space-sm);">🛒</div><h3 style="font-size:var(--font-size-md); font-weight:700; color:var(--color-primary);">Your cart is empty</h3><p style="font-size:var(--font-size-xs); color:var(--color-text-light); margin-top:4px;">Add trending products to enjoy fast shipping across India.</p><a href="/collections" class="btn btn--primary btn--sm" style="margin-top:var(--space-md);">Shop Winning Deals →</a></div>`;
        } else {
          let html = '';
          cart.items.forEach((item, index) => {
            html += `<div class="cart-drawer-item" style="display:flex; gap:var(--space-md); padding-bottom:var(--space-md); margin-bottom:var(--space-md); border-bottom:1px solid var(--color-border);"><img src="${item.image || NO_IMAGE_PLACEHOLDER}" alt="${item.title}" width="70" height="70" style="object-fit:cover; border-radius:var(--radius-md); border:1px solid var(--color-border);"><div style="flex:1; min-width:0;"><a href="${item.url}" style="font-size:var(--font-size-sm); font-weight:600; color:var(--color-primary); text-decoration:none; display:block; white-space:nowrap; overflow:hidden; text-overflow:ellipsis;">${item.title}</a>${item.variant_title && item.variant_title !== 'Default Title' ? `<div style="font-size:var(--font-size-xs); color:var(--color-text-light); margin-top:2px;">${item.variant_title}</div>` : ''}<div style="display:flex; align-items:center; justify-content:space-between; margin-top:8px;"><div style="display:inline-flex; align-items:center; border:1px solid var(--color-border); border-radius:var(--radius-sm); overflow:hidden;"><button type="button" onclick="updateDrawerQuantity(${index + 1}, ${item.quantity - 1})" style="padding:2px 8px; background:var(--color-background); border:none; cursor:pointer;">−</button><span style="padding:2px 10px; font-size:var(--font-size-xs); font-weight:600;">${item.quantity}</span><button type="button" onclick="updateDrawerQuantity(${index + 1}, ${item.quantity + 1})" style="padding:2px 8px; background:var(--color-background); border:none; cursor:pointer;">+</button></div><strong style="font-size:var(--font-size-sm); color:var(--color-primary);">${formatMoney(item.final_line_price)}</strong></div></div></div>`;
          });
          listEl.innerHTML = html;
        }
      }
      updateCartCount();
    } catch (err) { console.error('Failed to refresh drawer', err); }
  }

  window.updateDrawerQuantity = async function(line, quantity) {
    try {
      const response = await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ line, quantity }) });
      if (!response.ok) throw new Error('Cart update failed');
      await refreshCartDrawer();
    } catch (err) { showToast('Could not update quantity', 'error'); }
  };

  window.addUpsellWarranty = function() { console.warn('addUpsellWarranty is disabled: no real warranty product is configured.'); };

  function initHeaderCartDrawerTrigger() {
    $$('a[href="/cart"]').forEach(link => {
      link.addEventListener('click', (e) => { if (window.location.pathname !== '/cart') { e.preventDefault(); window.openCartDrawer(); } });
    });
  }

  function initCartPageQuantityAjax() {
    const cartPage = document.querySelector('.cart-page[data-section-id]');
    if (!cartPage) return;
    async function refreshCartPageSection() {
      const current = document.querySelector('.cart-page[data-section-id]');
      if (!current) return;
      const sectionId = current.dataset.sectionId;
      const res = await fetch(window.location.pathname + '?section_id=' + encodeURIComponent(sectionId), { headers: { 'Accept': 'text/html' } });
      if (!res.ok) throw new Error('Cart section refresh failed');
      const html = await res.text();
      const parent = current.parentNode;
      const wrapper = document.createElement('div');
      wrapper.innerHTML = html.trim();
      const newCartPage = wrapper.querySelector('.cart-page[data-section-id]') || wrapper.firstElementChild;
      if (newCartPage && parent) { parent.replaceChild(newCartPage, current); initQuantitySelectors(); updateCartCount(); }
    }
    if (document.body.dataset.cartAjaxDelegated) return;
    document.body.dataset.cartAjaxDelegated = 'true';
    let pending = false;
    async function changeLine(line, quantity, item) {
      if (pending) return;
      pending = true;
      if (item) item.style.opacity = '0.5';
      try {
        const response = await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ line, quantity }) });
        if (!response.ok) throw new Error('Cart update failed');
        await refreshCartPageSection();
      } catch (err) {
        showToast(quantity === 0 ? 'Could not remove item. Please try again.' : 'Could not update quantity. Please try again.', 'error');
        if (item) item.style.opacity = '1';
      } finally { pending = false; }
    }
    document.addEventListener('change', function(e) {
      const input = e.target.closest('.cart-page .quantity-selector__input[data-line]');
      if (!input) return;
      const line = parseInt(input.dataset.line, 10);
      let quantity = parseInt(input.value, 10);
      if (isNaN(quantity) || quantity < 0) quantity = 0;
      changeLine(line, quantity, input.closest('.cart-item'));
    });
    document.addEventListener('click', function(e) {
      const removeBtn = e.target.closest('.cart-page .cart-item__remove[data-line]');
      if (!removeBtn) return;
      e.preventDefault();
      const line = parseInt(removeBtn.dataset.line, 10);
      changeLine(line, 0, removeBtn.closest('.cart-item'));
    });
  }

  function initCartItemRemove() {}

  function initFaqToggles() {
    $$('.faq-toggle').forEach(btn => {
      btn.addEventListener('click', function() {
        const content = this.nextElementSibling;
        const icon = $('.faq-icon', this);
        const isOpen = content.style.display === 'block';
        content.style.display = isOpen ? 'none' : 'block';
        if (icon) icon.textContent = isOpen ? '+' : '−';
      });
    });
  }

  function initSalesNotifications() {}

  function init() {
    initStickyHeader(); initMobileMenu(); initHeroSlideshow(); initProductCarousels(); initReviewCarousel(); initProductGallery(); initProductTabs(); initVariantSelector(); initQuantitySelectors(); initAddToCart(); initScrollReveal(); initAnnouncementRotation(); initSearch(); initNewsletterForm(); initLazyLoad(); initHeaderCartDrawerTrigger(); initCartItemRemove(); initCartPageQuantityAjax(); updateCartCount(); initFaqToggles(); initSalesNotifications();
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }

})();


(function initSafeStarRatings() {
  function renderRatings(root) {
    (root || document).querySelectorAll('[data-rating-value]').forEach(function (el) {
      var raw = el.getAttribute('data-rating-value') || '';
      var match = String(raw).replace(',', '.').match(/\d+(?:\.\d+)?/);
      var value = match ? Number(match[0]) : 0;
      if (!Number.isFinite(value)) value = 0;
      value = Math.max(0, Math.min(5, value));
      el.style.setProperty('--rating-percent', (value / 5 * 100) + '%');
      el.setAttribute('aria-label', value.toFixed(value % 1 ? 1 : 0) + ' out of 5 stars');
    });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', function () { renderRatings(document); }, { once: true }); } else { renderRatings(document); }
  document.addEventListener('shopify:section:load', function (event) { renderRatings(event.target); });
})();

/* ---------- Mobile Full-Screen Predictive Search ---------- */
(function(){
  let timer;
  let controller;
  const esc = (v) => String(v ?? '').replace(/[&<>'"]/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[c]));
  // FIX: local copy of the money formatter. This IIFE is a separate closure
  // from the main theme.js IIFE above and cannot see its `formatMoney`.
  // Calling the outer one here previously threw "formatMoney is not defined"
  // on every keystroke, silently falling into the catch block and always
  // showing "Live preview unavailable right now." — this was the mobile
  // search live-preview bug.
  function formatMoney(cents) { return '₹' + (cents / 100).toLocaleString('en-IN'); }
  const MOBILE_NO_IMG = 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">' +
    '<rect width="100" height="100" fill="#EEF1F5"/>' +
    '<path d="M30 65 L42 50 L52 60 L66 42 L78 65 Z" fill="#C7CEDB"/>' +
    '<circle cx="38" cy="35" r="7" fill="#C7CEDB"/>' +
    '</svg>'
  );
  function initMobileSearch(){
    const overlay=document.getElementById('MobileSearchOverlay');
    const input=document.getElementById('MobileSearchInput');
    const results=document.getElementById('MobileSearchResults');
    if(!overlay||!input||!results) return;
    const close=()=>{overlay.classList.remove('is-open');overlay.setAttribute('aria-hidden','true');document.body.classList.remove('mobile-search-open');document.querySelectorAll('.mobile-search-trigger').forEach(b=>b.setAttribute('aria-expanded','false'));if(controller) controller.abort();};
    window.openMobileSearch=()=>{overlay.classList.add('is-open');overlay.setAttribute('aria-hidden','false');document.body.classList.add('mobile-search-open');document.querySelectorAll('.mobile-search-trigger').forEach(b=>b.setAttribute('aria-expanded','true'));setTimeout(()=>input.focus(),40);if(!input.value) results.innerHTML='<div class="mobile-search-overlay__hint">Start typing to instantly find products.</div>';};
    overlay.querySelectorAll('[data-search-close]').forEach(el=>el.addEventListener('click',close));
    document.addEventListener('keydown',e=>{if(e.key==='Escape'&&overlay.classList.contains('is-open'))close();});
    input.addEventListener('input',()=>{
      clearTimeout(timer); const q=input.value.trim();
      if(controller) controller.abort();
      if(q.length<2){results.innerHTML='<div class="mobile-search-overlay__hint">Type at least 2 characters to search.</div>';return;}
      results.innerHTML='<div class="mobile-search-overlay__hint">Searching…</div>';
      timer=setTimeout(async()=>{
        controller=new AbortController();
        try{
          const r=await fetch(`/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last`,{signal:controller.signal,headers:{Accept:'application/json'}});
          if(!r.ok) throw new Error('suggest.json responded with HTTP '+r.status);
          const ct=r.headers.get('content-type')||'';
          if(ct.indexOf('json')===-1){ throw new Error('suggest.json returned non-JSON content-type "'+ct+'" — store may be password-protected or this preview is not the live storefront domain'); }
          const data=await r.json(); const products=data?.resources?.results?.products||[];
          if(!products.length){results.innerHTML='<div class="mobile-search-overlay__hint">No products found for "'+esc(q)+'". Try another keyword.</div>';return;}
          results.innerHTML=products.map(p=>{
            const img=p.image||p.featured_image?.url||p.featured_image||MOBILE_NO_IMG;
            const url=p.url||('/products/'+(p.handle||''));
            const rawPrice=typeof p.price==='number'?p.price:parseFloat(String(p.price||'').replace(/[^0-9.]/g,''));
            const price=Number.isFinite(rawPrice)?formatMoney(rawPrice*100):'';
            return `<a class="mobile-search-result" href="${esc(url)}"><img src="${esc(img)}" alt="${esc(p.title)}" width="58" height="58" loading="lazy"><span><span class="mobile-search-result__title">${esc(p.title)}</span><span class="mobile-search-result__price">${esc(price)}</span></span></a>`;
          }).join('')+`<a class="mobile-search-result__all" href="/search?type=product&q=${encodeURIComponent(q)}">View all results for "${esc(q)}"</a>`;
        }catch(e){
          if(e.name==='AbortError') return;
          console.error('[mobile predictive search] request failed:', e);
          results.innerHTML='<div class="mobile-search-overlay__hint">Live preview unavailable right now.</div><a class="mobile-search-result__all" href="/search?type=product&q='+encodeURIComponent(q)+'">View all results for \u201c'+esc(q)+'\u201d \u2192</a>';
        }
      },180);
    });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',initMobileSearch); else initMobileSearch();
})();
